import React, { useEffect, useState, useRef } from 'react'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector } from 'react-redux'
import { EditorState, convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import moblogo from '../../assets/moblogo.svg'

export const ClipContentMob = (props, isActive) => {

  const [listing] = useState(props.listing);
  const [editorState, setEditorState] = useState(null);
  const isAdmin = useSelector(state => state.isAdmin)
  const videoRef = useRef(null);
  const [showButton, setShowButton] = useState(false)
  let hideTimeout = null;

  const [videoLoaded, setVideoLoaded] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const clipUrlData = "Aajubaaju My Clips"
  const clipUrl = clipUrlData.replace(/[\s]/gm, '-')
  const isSharedPage = window.location.pathname.includes('/shareclips/');
  // [firstClipHandled, setFirstClipHandled] = useState(false);
  // const [isBuffering, setIsBuffering] = useState(false);

  // useEffect(() => {
  //   const video = videoRef.current;
  //   if (!video) return;

  //   if (isSharedPage && props.isActive) {
  //     video.pause();
  //     video.muted = false;
  //     setShowButton(true); // Show play button
  //     // setFirstClipHandled(true);
  //   } else if (props.isActive) {
  //     video.muted = false;
  //     video.play().catch(() => { });
  //     setShowButton(false);

  //   } else {
  //     video.pause();
  //     video.muted = true;
  //     // setShowButton(true);
  //     setShowButton(false);
  //   }

  //   if (video) {
  //     // Disable Picture-in-Picture
  //     video.disablePictureInPicture = true;

  //     // Prevent PiP mode
  //     video.addEventListener("enterpictureinpicture", (event) => {
  //       event.preventDefault();
  //       document.exitPictureInPicture();
  //     });

  //     // Safari-specific fix
  //     video.addEventListener("webkitpresentationmodechanged", () => {
  //       if (video.webkitPresentationMode === "picture-in-picture") {
  //         video.webkitSetPresentationMode("inline");
  //       }
  //     })
  //   }
  // }, [props.isActive]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // 💡 NEW LOGIC: Check if it's the very first clip (index 0)
    const isFirstClip = props.index === 0;

    if (props.isActive) {
      // --- Clip becomes Active (Swiped to or Initial Load) ---

      // 1. Only pause if it is the shared page AND the FIRST clip
      if (isSharedPage && isFirstClip) {
        video.pause();
        video.muted = false;
        setShowButton(true); // Show play button
      } 
      // 2. Auto-play ALL subsequent clips (index > 0)
      else {
        video.muted = false; // Allow sound
        // Mute video on auto-play for better browser compliance, 
        // and let the user unmute it if needed.
        // For now, keeping it unmuted as per original code.
        video.play().catch(() => { }); 
        setShowButton(false);
      }

    } else {
      // --- Clip becomes Inactive (Swiped away) ---
      video.pause();
      video.muted = true;
      setShowButton(false);
    }

    if (video) {
      // Disable Picture-in-Picture
      video.disablePictureInPicture = true;

      // Prevent PiP mode
      video.addEventListener("enterpictureinpicture", (event) => {
        event.preventDefault();
        document.exitPictureInPicture();
      });

      // Safari-specific fix
      video.addEventListener("webkitpresentationmodechanged", () => {
        if (video.webkitPresentationMode === "picture-in-picture") {
          video.webkitSetPresentationMode("inline");
        }
      })
    }
    // 💡 FIX 2: Added props.index to dependencies
  }, [props.isActive, isSharedPage, props.index]);

  const handleVideoClick = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video.play();
      setShowButton(false);
      clearTimeout(hideTimeout);
      //hideTimeout = setTimeout(() => setShowButton(true), 1000);
    } else {
      video.pause();
      setShowButton(true);
      //clearTimeout(hideTimeout);
    }
  };

  // const handleVideoLoad = () => setVideoLoaded(true);

  const handleVideoLoad = () => {
    setVideoLoaded(true);
  };

  useEffect(() => {
    if (videoLoaded) {
      setShowContent(true);
    }
  }, [videoLoaded]);

  const { element } = props;


  useEffect(() => {
    if (listing.listingType === 'clips') {
      if (listing.myvideos_content) {
        const con = JSON.parse(listing.myvideos_content)
        const contentState = convertFromRaw(con);
        setEditorState(EditorState.createWithContent(contentState))
      }
    }
  }, [listing]);


  const clipshare = (event) => {
    event.preventDefault();
    const businessName = props.listing.businessName.replace(/[^\w\s^&]/gm, ' ').trim().replace(/[\s]/gm, '-')
    const shareUrl = `${window.location.origin}/shareclips/${businessName}/${props.listing.hpId}`;

    if (navigator.share) {
      navigator.share({
        title: 'Where to Share',
        url: [shareUrl]
      }).then(() => {
        console.log('Thanks for sharing!');
      }).catch(console.error);
    } else {
      const shareDialog = document.querySelector('.share-dialog');
      if (shareDialog) {
        shareDialog.classList.add('is-open');
      }
    }
  };


  if (!props.listing.hpId)
    return <> </>
  else {
    return (
      <>
        {props.listing.elements.map((element, index) => (
          <div key={element.value + index}>
            {element.type === 'video' ?
              <div className="video-container-mob">
                <video
                  className='clip_video_mob'
                  ref={videoRef}
                  src={process.env.REACT_APP_IMAGES_URL + element.value}
                  loop
                  playsInline
                  muted
                  id="myVideoMob"
                  onLoadedData={handleVideoLoad}
                  onClick={handleVideoClick}
                ></video>
                {showContent && (
                  <>
                    <div style={{
                      position: 'absolute',
                      top: '10px',
                      left: '10px',
                      zIndex: 2
                    }}>
                      <Link to="/">
                        <img
                          src={moblogo}
                          alt="Logo"
                          style={{ width: "45vw", maxWidth: "50px", maxHeight: "50px" }}
                        />
                      </Link>
                    </div>

                    {showButton &&
                      <button className="play-pause-button" onClick={handleVideoClick}>
                        <i className="fa fa-play styled-icon" style={{ fontSize: '24px', color: 'white' }}></i>
                      </button>
                    }

                    <div className="button-container-mob">
                      <Link className="clip-button-mob" onClick={clipshare}>
                        <i className='fa fa-share styled-icon btnIconMob'></i>
                      </Link>
                      {props.listing.subCategories.map((subcategory) => (
                        <Link
                          key={subcategory.id}
                          to={`/content/${clipUrl}/${subcategory.subCategory.replace(/[\s]/gm, '-')}/clips`}
                          className="watch-button-mob"
                        >
                          <i className='fa fa-eye styled-icon btnIconMob'></i>
                        </Link>
                      ))}
                    </div>

                    {isAdmin && listing.myvideos_content !== '' && listing.listingType === 'clips' ?
                      <div className="rdw-storybook-root">
                        <Editor
                          editorState={editorState}
                          wrapperClassName="rdw-storybook-wrapper"
                          readOnly
                          toolbarHidden
                        />
                      </div> : null}

                  </>)}
              </div>

              : null}
          </div>
        ))}
      </>
    )
  }
}

export default (ClipContentMob); 
